import libphonenumber from 'libphonenumber-js';

export function getGlobalHandle() {
  return window as any;
}

export const testMobileNumber = (number: string): boolean => {
  return libphonenumber(number)?.isValid() || false;
};

export const initialHelper = (fullName: string): string => {
  const names: string[] = fullName?.split(' ') || [];
  if (names.length === 0) {
    return '';
  }
  let initials = names[0].substring(0, 1);
  if (names.length > 1) {
    initials = initials + names[names.length - 1].substring(0, 1);
  } else {
    if (names[0].length > 1) {
      initials = names[0].substring(0, 2);
    }
  }
  return initials.toUpperCase();
};

export const validateEmail = (email: string): boolean => {
  // eslint-disable-next-line no-control-regex
  const pattern = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])?$/;
  return pattern.test(email);
};

export function capitalizeFirstLetter(string): string {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function throttle(func: Function, rate: number) {
  let enabled = true;

  return function (arg?: any) {
    if (enabled) {
      func(arg);
      enabled = false;
      setTimeout(() => {
        enabled = true;
      }, rate);
    }
  };
}
